import type { UniDriver } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { buttonDriverFactory } from '../Button/Button.uni.driver';

export const selectorButtonDriverFactory = (base: UniDriver) => {
  const buttonDriver = buttonDriverFactory(base);

  return {
    ...baseUniDriverFactory(base),

    /** Gets button text */
    getButtonTextContent: () => buttonDriver.getButtonTextContent(),

    /** Checks whether button is focused */
    isFocused: () => buttonDriver.isFocused(),

    /** Checks whether button is disabled */
    isDisabled: () => buttonDriver.isButtonDisabled(),

    /** Checks whether button has suffix */
    hasSuffix: () => buttonDriver.isSuffixIconExists(),
  };
};

export type SelectorButtonUniDriver = ReturnType<
  typeof selectorButtonDriverFactory
>;
